import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Badge,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import { ORDERS_STATUS, USER_TYPE } from "../../../dummyData/dummyData";
import DataTable, { TableColumn } from "react-data-table-component";
import {
  useUpdateBulkOrderStatusMutation,
  useIssueBulkOrderMutation,
} from "../../../redux/services/orderService";
import { useGetCartsForRestaurantByRestaurantIdQuery } from "../../../redux/services/restaurantServices";
import { faEye, faPrint, faRedo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BreadCrumbs from "../../../components/BreadCrumbs";
import "./index.css";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  dateTFormat,
  formatFirestoreTimestamp,
} from "../../../utility/Utility";
import {
  BULK_ACTIONS,
  ORDER_CREATED_BY_CART_PERSON,
  ORDER_CREATED_BY_CUSTOMER,
} from "../../../constants/constans";
import {
  setRowsPerPage,
  setSelectedOrderCreatedBy,
  setSelectedOrderDate,
  setSelectedOrderEndDate,
  setSelectedOrderType,
  setSelectedCartName,
  clearSelectedCartName,
  setSelectedAgentSourceFilter,
} from "../../../redux/orderSlice";
import TableLoadingComponent from "../../../components/TableLoadingComponent";
import PrintSetupModal from "./PrintModel";
import { toast } from "react-toastify";
import ProductSummaryPrintModal from "./ProductSummaryPrintModel";
import ButtonComponent from "../../../components/ButtonComponent";
import { useFirebaseOrders } from "../../../hooks/useFirebaseOrders";

export interface customItems {
  unitPrice: number;
  displayName: string;
  menuItemId: string;
}

export interface OrderItem {
  unitPrice: number;
  tinyId?: number;
  unitTotalPrice?: number;
  itemType: string;
  quantity: number;
  displayName: string;
  menuItemId: string;
  customItems?: customItems[];
  isExpanded?: boolean;
  portionSize?: string;
  perItemManualDiscount?: number;
}

export interface Order {
  walletPaymentAmount: any;
  isDirectRestaurantOrder: boolean;
  id: string;
  isDeliveryOrder?: boolean;
  restaurantId: string;
  address: string;
  phoneNumber?: string;
  deliveryStatus?: string;
  paymentMethod: string;
  displayName: string;
  orderStatus: string;
  paymentCompleted: boolean;
  orderItems: OrderItem[];
  orderCreatedBy: string;
  isSplitOrder?: boolean;
  parentOrderId?: string;
  orderReference: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt?: {
    _seconds: number;
    _nanoseconds: number;
  };
  deliverAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  totalPrice: number;
  cart?: any;
  customer?: any;
  isScheduledOrder: boolean;
  paymentSummary: {
    totalPrice: number;
    netAmount: number;
    cartCommission: number;
    cardPaymentAmount: number;
    cashPaymentAmount: number;
    walletPaymentAmount: number;
    deliveryFee?: number;
    isDeliveryFree?: boolean;
    discount?: number;
    isManualDeliveryFee?: boolean;
    isManualDiscount?: boolean;
    manualDiscountType?: "Fixed" | "Percentage";
    manualDiscountAmount?: number;
  };
  selected: boolean;
  updateNote?: string;
  deliveryDetails?: {
    coordinates?: {
      latitude: number;
      longitude: number;
    };
    address?: string;
    deliverAt?: {
      _seconds: number;
      _nanoseconds: number;
    };
    deliveryContactName?: string;
    deliveryContactPhoneNumber?: string;
    deliveryInstructions?: string;
  };
  orderNote?: string;
  packingNote?: string;
  paymentNote?: string;
  organization?: any;
  deliveryTimeSlot?: string;
  pickupTimeSlot?: string;
  orderTakenBy?: {
    displayName?: string;
    userId: string;
  };
  orderSource?: "CallCenter" | "CustomerApp" | "CustomerWeb";
  promoCode?: string;
  deliveryCart?: {
    cartId: string;
    displayName: string;
  };
}

// Updated STATUS_FLOW with new flow
export const STATUS_FLOW = [
  "Pending",
  "ApprovedByRestaurant",
  "Preparing",
  "ReadyAtKitchen",
  "IssuedByKitchen",
  "ArrivedAtCart",
  "PackingComplete",
  "Completed",
  "Cancelled",
];

const ALL_AGENT_SOURCE_OPTION = { value: "all", label: "All", type: "all" };

const OrderListNew = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const restaurantId = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id,
  );

  const orderCreatedBy = useSelector(
    (state: any) => state.order.orderCreatedBy,
  );
  const orderStatus = useSelector((state: any) => state.order.orderStatus);
  const startDate = useSelector((state: any) => state.order.orderDate);
  const endDate = useSelector((state: any) => state.order.orderEndDate);
  const rowsPerPage = useSelector((state: any) => state.order.rowsPerPage);
  const cartName = useSelector((state: any) => state.order.cartName);
  const agentSourceFilter = useSelector(
    (state: any) => state.order.agentSourceFilter,
  );

  const [orderList, setOrderList] = useState<Order[]>([]);
  const [allOrders, setAllOrders] = useState<Order[]>([]);
  const [selectedOrders, setSelectedOrders] = useState<string[]>([]);
  const [bulkAction, setBulkAction] = useState<{
    value: string;
    label: string;
  } | null>(null);
  const [showBulkStatusModal, setShowBulkStatusModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOrderStatus, setSelectedOrderStatus] = useState({
    value: orderStatus,
    label: orderStatus,
  });
  const [orderType, setOrderType] = useState({
    value: orderCreatedBy,
    label: orderCreatedBy,
  });
  const [selectedCart, setSelectedCart] = useState<any>(null);
  const [selectedAgent, setSelectedAgent] = useState<any>(
    agentSourceFilter || ALL_AGENT_SOURCE_OPTION,
  );
  const [agentOptions, setAgentOptions] = useState<any>([]);
  const [organizationOptions, setOrganizationOptions] = useState<any[]>([]);
  const [selectedOrganization, setSelectedOrganization] = useState<any>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isDateSelected, setIsDateSelected] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isStatusChanged, setIsStatusChanged] = useState(false);

  const startDateObj = startDate
    ? new Date(startDate.split("T")[0] + "T00:00:00")
    : new Date(new Date().toISOString().split("T")[0] + "T00:00:00");
  const endDateObj = endDate
    ? new Date(endDate.split("T")[0] + "T23:59:59")
    : new Date(new Date().toISOString().split("T")[0] + "T23:59:59");

  const { data: ordersData, loading: isLoading } = useFirebaseOrders(
    restaurantId,
    startDateObj,
    endDateObj,
  );
  const [updateBulkOrderStatus, { isLoading: isUpdatingBulkStatus }] =
    useUpdateBulkOrderStatusMutation();
  const [showOrderPrintModal, setShowOrderPrintModal] = useState(false);
  const [showProductPrintModal, setShowProductPrintModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState<any>([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [currentStatusForSelected, setCurrentStatusForSelected] =
    useState<string>("");
  const [nextStatusOption, setNextStatusOption] = useState<{
    value: string;
    label: string;
  } | null>(null);
  const [showSummaryView, setShowSummaryView] = useState(false);

  const { data: cartsData, isLoading: cartsLoading } =
    useGetCartsForRestaurantByRestaurantIdQuery(restaurantId, {
      skip: !restaurantId || orderType?.value === "Restaurant",
    });

  const [issueBulkOrder, { isLoading: isIssuingBulkOrder }] =
    useIssueBulkOrderMutation();

  const handlePrintModalOpen = () => {
    if (showSummaryView) {
      setShowProductPrintModal(true);
    } else {
      setShowOrderPrintModal(true);
    }
  };

  const handleOrderPrintModalClose = () => setShowOrderPrintModal(false);
  const handleProductPrintModalClose = () => setShowProductPrintModal(false);

  const handleSearchQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (!query) {
      setOrderList(allOrders);
      return;
    }

    const filteredData = allOrders.filter((order) => {
      const searchableFields = [
        order.orderReference?.toLowerCase() || "",
        order.customer?.displayName?.toLowerCase() || "",
        order.organization?.displayName?.toLowerCase() || "",
        order.phoneNumber?.toLowerCase() || "",
        order.cart?.displayName?.toLowerCase() || "",
      ];

      return searchableFields.some((field) => field.includes(query));
    });

    setOrderList(filteredData);
  };

  const getNextStatus = (currentStatus: string) => {
    // Handle Pending status
    if (currentStatus === "Pending") {
      return {
        value: "ApprovedByRestaurant",
        label: "Approved By Restaurant",
      };
    }

    const currentIndex = STATUS_FLOW.indexOf(currentStatus);
    if (currentIndex === -1 || currentIndex >= STATUS_FLOW.length - 1) {
      return null;
    }

    const nextStatus = STATUS_FLOW[currentIndex + 1];
    return {
      value: nextStatus,
      label: nextStatus.replace(/([A-Z])/g, " $1").trim(),
    };
  };

  const isOrderSelectable = (order: Order) => {
    // Don't allow selection of:
    // - Completed orders
    // - Cancelled orders
    // - Tentative orders
    // - PackingComplete orders
    if (
      order.orderStatus === "Completed" ||
      order.orderStatus === "Cancelled" ||
      order.orderStatus === "Tentative"
    ) {
      return false;
    }

    // If no orders are selected yet, allow selection
    if (selectedOrders.length === 0) {
      return true;
    }

    // If orders are already selected, only allow selection of orders with same status
    const firstOrder = orderList.find((o) => o.id === selectedOrders[0]);
    return firstOrder && order.orderStatus === firstOrder.orderStatus;
  };

  const handleOrderSelection = (orderId: string) => {
    const order = orderList.find((o) => o.id === orderId);
    if (!order) return;

    if (!isOrderSelectable(order)) {
      if (order.orderStatus === "PackingComplete") {
        toast.info("Packing Complete orders cannot be modified");
      } else if (selectedOrders.length > 0) {
        const firstOrder = orderList.find((o) => o.id === selectedOrders[0]);
        toast.error(
          `You can only select orders with status "${firstOrder?.orderStatus}" for bulk actions`,
        );
      }
      return;
    }

    let newSelectedOrders: string[];
    if (selectedOrders.includes(orderId)) {
      newSelectedOrders = selectedOrders.filter((id) => id !== orderId);
      setCurrentStatusForSelected(
        newSelectedOrders.length > 0 ? currentStatusForSelected : "",
      );
    } else {
      if (selectedOrders.length === 0) {
        setCurrentStatusForSelected(order.orderStatus);
        newSelectedOrders = [orderId];
      } else {
        newSelectedOrders = [...selectedOrders, orderId];
      }
    }

    setSelectedOrders(newSelectedOrders);
  };

  const getSelectableOrders = () => {
    return orderList.filter((order) => isOrderSelectable(order));
  };

  const handleSelectAllOrders = () => {
    const selectableOrders = getSelectableOrders();

    if (selectableOrders.length === 0) {
      toast.info("No selectable orders available");
      return;
    }

    if (selectedOrders.length === selectableOrders.length) {
      setSelectedOrders([]);
      setCurrentStatusForSelected("");
    } else {
      setSelectedOrders(selectableOrders.map((order) => order.id));
      if (selectableOrders.length > 0) {
        setCurrentStatusForSelected(selectableOrders[0].orderStatus);
      }
    }
  };

  const handleIssueOrders = async () => {
    if (selectedOrders.length === 0) {
      toast.error("Please select orders to issue");
      return;
    }

    try {
      await issueBulkOrder({
        orderIds: selectedOrders,
      }).unwrap();

      toast.success(`Issued ${selectedOrders.length} orders`);
      setSelectedOrders([]);
      setCurrentStatusForSelected("");
      setBulkAction(null);
    } catch (error: any) {
      const message = error.data?.message || "Failed to issue orders";
      toast.error(message);
    } finally {
      setShowConfirmModal(false);
    }
  };

  const handleBulkActionChange = (selectedOption: any) => {
    setBulkAction(selectedOption);

    if (selectedOption?.value === "changeStatus" && selectedOrders.length > 0) {
      const firstOrder = orderList.find((o) => o.id === selectedOrders[0]);
      if (firstOrder) {
        const nextStatus = getNextStatus(currentStatusForSelected);
        
        // Don't proceed if no next status available
        if (!nextStatus) {
          toast.error("No next status available for selected orders");
          setBulkAction(null);
          return;
        }
        
        setNextStatusOption(nextStatus);
        setShowBulkStatusModal(true);
      }
    } else if (selectedOption?.value === "issue") {
      setShowConfirmModal(true);
    }
  };

  const handleBulkActionSubmit = async () => {
    if (!bulkAction || !nextStatusOption || selectedOrders.length === 0) {
      toast.error("Please select an action and status");
      return;
    }

    try {
      await updateBulkOrderStatus({
        orderIds: selectedOrders,
        orderStatus: nextStatusOption.value,
      }).unwrap();

      toast.success(
        `Updated ${selectedOrders.length} orders to ${nextStatusOption.label}`,
      );
      setSelectedOrders([]);
      setCurrentStatusForSelected("");
      setBulkAction(null);
      setNextStatusOption(null);
      setShowBulkStatusModal(false);
    } catch (error) {
      toast.error("Failed to update orders");
    }
  };

  // Filter bulk actions based on current status
  const filteredBulkActions = BULK_ACTIONS.filter(action => {
    // Disable "issue" action for non-PaymentComplete orders
    if (action.value === "issue" && currentStatusForSelected !== "PaymentComplete") {
      return false;
    }
    return true;
  });

  const applyAgentFilter = (orders: Order[]) => {
    if (!selectedAgent || selectedAgent.value === "all") {
      return orders;
    }

    return orders.filter((order: Order) => {
      if (selectedAgent.type === "agent") {
        return (
          order.orderSource === "CallCenter" &&
          order.orderTakenBy?.displayName === selectedAgent.label
        );
      } else if (selectedAgent.type === "source") {
        return order.orderSource === selectedAgent.value;
      }
      return true;
    });
  };

  const applyFilters = (orders: Order[]) => {
    let filteredOrders = orders;

    if (orderType?.value === "Customer") {
      filteredOrders = filteredOrders.filter(
        (order: Order) => order.orderCreatedBy === "Customer",
      );
    } else if (orderType?.value === "Cart") {
      filteredOrders = filteredOrders.filter(
        (order: Order) => order.orderCreatedBy === "CartPerson",
      );
    } else if (orderType?.value === "Restaurant") {
      filteredOrders = filteredOrders.filter(
        (order: Order) => order.orderCreatedBy === "Restaurant",
      );
    }

    if (selectedCart && selectedCart.cartId !== "all") {
      filteredOrders = filteredOrders.filter(
        (order: Order) => order.cart?.cartId === selectedCart.cartId,
      );
    }

    if (selectedOrganization && selectedOrganization.value !== "all") {
      filteredOrders = filteredOrders.filter(
        (order: Order) =>
          order.organization &&
          order.organization.organizationId === selectedOrganization.value,
      );
    }

    if (selectedOrderStatus?.value && selectedOrderStatus.value !== "All") {
      filteredOrders = filteredOrders.filter(
        (order: Order) => order.orderStatus === selectedOrderStatus.value,
      );
    }

    filteredOrders = applyAgentFilter(filteredOrders);

    return filteredOrders;
  };

  useEffect(() => {
    if (allOrders.length > 0) {
      const orgMap = new Map();
      allOrders.forEach((order) => {
        if (
          order.organization &&
          order.organization.organizationId &&
          order.organization.displayName
        ) {
          orgMap.set(
            order.organization.organizationId,
            order.organization.displayName,
          );
        }
      });
      const orgOptions = Array.from(orgMap.entries()).map(
        ([id, displayName]) => ({
          value: id,
          label: displayName,
        }),
      );
      const allOption = { value: "all", label: "All" };
      setOrganizationOptions([allOption, ...orgOptions]);
      if (!selectedOrganization) setSelectedOrganization(allOption);
    }
  }, [allOrders, selectedOrganization]);

  useEffect(() => {
    if (allOrders.length > 0) {
      const filteredOrders = applyFilters(allOrders);
      setOrderList(filteredOrders);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  const handleOrganizationChange = (selectedOption: any) => {
    setSelectedOrganization(selectedOption || { value: "all", label: "All" });
  };

  useEffect(() => {
    if (allOrders.length > 0) {
      const agents = new Set<string>();
      const sources = new Set<string>();

      allOrders.forEach((order) => {
        if (
          order.orderSource === "CallCenter" &&
          order.orderTakenBy?.displayName
        ) {
          agents.add(order.orderTakenBy.displayName);
        }
        if (order.orderSource && order.orderSource !== "CallCenter") {
          sources.add(order.orderSource);
        }
      });

      const agentOpts = Array.from(agents)
        .sort()
        .map((agent) => ({
          value: agent,
          label: agent,
          type: "agent",
        }));

      const sourceOpts = Array.from(sources)
        .sort()
        .map((source) => ({
          value: source,
          label:
            source === "CustomerApp"
              ? "Customer App"
              : source === "CustomerWeb"
                ? "Customer Web"
                : source === "WhatsApp"
                  ? "WhatsApp"
                  : source,
          type: "source",
        }));

      const computedAgentOptions = [
        ALL_AGENT_SOURCE_OPTION,
        ...agentOpts,
        ...sourceOpts,
      ];

      setAgentOptions(computedAgentOptions);

      const matchedSelectedAgent = computedAgentOptions.find(
        (option) =>
          option.value === selectedAgent?.value &&
          option.type === selectedAgent?.type,
      );

      if (
        matchedSelectedAgent &&
        (matchedSelectedAgent.value !== selectedAgent?.value ||
          matchedSelectedAgent.type !== selectedAgent?.type)
      ) {
        setSelectedAgent(matchedSelectedAgent);
      }
    }
  }, [allOrders, selectedAgent]);

  useEffect(() => {
    if (cartsData && orderType?.value !== "Restaurant") {
      const cartOptions = cartsData
        .filter((cart: any) => cart?.cartType === "Fixed")
        .map((cart: any) => ({
          value: cart.id,
          label: cart.displayName || cart.name,
          cartId: cart.id,
          displayName: cart.displayName || cart.name,
        }))
        .sort((a: any, b: any) => a.label.localeCompare(b.label));

      const allOption = {
        value: "all",
        label: "All",
        cartId: "all",
        displayName: "All",
      };

      setSearchOptions([allOption, ...cartOptions]);

      if (cartName) {
        const matchingCart = [allOption, ...cartOptions].find(
          (cart: any) => cart.label === cartName,
        );
        if (matchingCart) {
          setSelectedCart(matchingCart);
        }
      } else {
        setSelectedCart(allOption);
        dispatch(setSelectedCartName("All"));
      }
    }
  }, [cartsData, orderType, cartName, dispatch]);

  useEffect(() => {
    if (allOrders.length > 0) {
      const filteredOrders = applyFilters(allOrders);
      setOrderList(filteredOrders);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAgent]);

  useEffect(() => {
    if (ordersData && ordersData.orders) {
      const nonDeliveryOrders = ordersData.orders.filter(
        (order: any) => order.isDeliveryOrder !== true,
      );

      const sortedNonDeliveryOrders = [...nonDeliveryOrders].sort((a, b) =>
        (b.orderReference || "").localeCompare(a.orderReference || "", undefined, {
          numeric: true,
          sensitivity: "base",
        }),
      );

      const filteredOrders = applyFilters(sortedNonDeliveryOrders);
      setAllOrders(sortedNonDeliveryOrders);
      setOrderList(filteredOrders);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordersData, selectedCart, orderType, selectedAgent, selectedOrderStatus]);

  const handleViewDetails = (order: Order) => {
    navigate("/orders/pickup-orders/view", { state: { orderId: order.id } });
  };

  const handleReorder = (order: Order) => {
    navigate("/orders/create-order", {
      state: {
        reorderData: {
          isDeliveryOrder: order.isDeliveryOrder ?? false,
          orderCreatedBy: order.orderCreatedBy,
          customer: order.customer ?? null,
          cart: order.cart ?? null,
          organization: order.organization ? {
            organizationId: order.organization.organizationId || order.organization.id,
            id: order.organization.id || order.organization.organizationId,
            displayName: order.organization.displayName,
            phoneNumber: order.organization.phoneNumber,
          } : null,
          phoneNumber: order.phoneNumber ?? order.customer?.phoneNumber ?? null,
          paymentMethod: order.paymentMethod ?? null,
          orderNote: order.orderNote ?? "",
          packingNote: order.packingNote ?? "",
          paymentNote: order.paymentNote ?? "",
          deliveryDetails: order.deliveryDetails ?? null,
          deliveryTimeSlot: order.deliveryTimeSlot ?? null,
          pickupTimeSlot: order.pickupTimeSlot ?? null,
          paymentSummary: order.paymentSummary ?? null,
          isManualDeliveryFee: order.paymentSummary?.isManualDeliveryFee ?? false,
          manualDeliveryFee: order.paymentSummary?.isManualDeliveryFee
            ? (order.paymentSummary?.deliveryFee ?? 0)
            : null,
          orderItems: (order.orderItems || []).map((item: any) => ({
            id: item.menuItemId,
            menuItemId: item.menuItemId,
            tinyId: item.tinyId,
            skuId: item.skuId,
            displayName: item.displayName,
            price: item.unitPrice,
            calculatedPrice: item.unitPrice,
            quantity: item.quantity,
            portionLabel: item.portionSize || "Regular",
            itemType: item.itemType,
            customItems: item.customItems || [],
          })),
        },
      },
    });
  };

  const handleOrderDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedStartDate = new Date(e.target.value);
    const currentEndDate = new Date(endDate.split("T")[0]);

    if (selectedStartDate > currentEndDate) {
      toast.error("Start date cannot be after end date");
      return;
    }

    const selectedDate = dateTFormat(selectedStartDate);
    setIsDateSelected(!!e.target.value);
    dispatch(setSelectedOrderDate(selectedDate));
  };

  const handleOrderEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedEndDate = new Date(e.target.value);
    const currentStartDate = new Date(startDate.split("T")[0]);

    if (selectedEndDate < currentStartDate) {
      toast.error("End date cannot be before start date");
      return;
    }

    const selectedDate = dateTFormat(selectedEndDate);
    dispatch(setSelectedOrderEndDate(selectedDate));
  };

  const handleStatusChange = (selectedOption: any) => {
    const orderStatus = selectedOption ? selectedOption.value : null;
    setIsStatusChanged(true);
    setSelectedOrderStatus(selectedOption);
    dispatch(setSelectedOrderType(orderStatus));
  };

  const handleOrderCreatedByChange = (selectedOption: any) => {
    const orderCreatedBy = selectedOption ? selectedOption.value : null;
    setOrderType(selectedOption);
    dispatch(setSelectedOrderCreatedBy(orderCreatedBy));
  };

  const handleCartSelect = (selectedOption: any) => {
    setSelectedCart(selectedOption);

    if (!selectedOption) {
      dispatch(clearSelectedCartName());
      return;
    }

    dispatch(setSelectedCartName(selectedOption.label));
  };

  const handleAgentChange = (selectedOption: any) => {
    const nextOption = selectedOption || ALL_AGENT_SOURCE_OPTION;
    setSelectedAgent(nextOption);
    dispatch(setSelectedAgentSourceFilter(nextOption));
  };

  const handleInputChange = (inputValue: string) => {
    if (!inputValue || inputValue.length === 0) {
      if (cartsData && orderType?.value !== "Restaurant") {
        const cartOptions = cartsData
          .filter((cart: any) => cart?.cartType === "Fixed")
          .map((cart: any) => ({
            value: cart.id,
            label: cart.displayName || cart.name,
            cartId: cart.id,
            displayName: cart.displayName || cart.name,
          }))
          .sort((a: any, b: any) => a.label.localeCompare(b.label));

        const allOption = {
          value: "all",
          label: "All",
          cartId: "all",
          displayName: "All",
        };

        setSearchOptions([allOption, ...cartOptions]);
      }
      return;
    }

    if (cartsData && orderType?.value !== "Restaurant") {
      const filteredCarts = cartsData.filter(
        (cart: any) =>
          cart?.cartType === "Fixed" &&
          (cart.displayName || cart.name)
            .toLowerCase()
            .includes(inputValue.toLowerCase()),
      );

      const cartOptions = filteredCarts
        .map((cart: any) => ({
          value: cart.id,
          label: cart.displayName || cart.name,
          cartId: cart.id,
          displayName: cart.displayName || cart.name,
        }))
        .sort((a: any, b: any) => a.label.localeCompare(b.label));

      setSearchOptions(cartOptions);
    }
  };

  const handleChangeRowsPerPage = (newRowsPerPage: number) => {
    dispatch(setRowsPerPage(newRowsPerPage));
  };

  const getMenuItemCounts = () => {
    const itemCounts: Record<
      string,
      {
        name: string;
        totalCount: number;
        reservedCount: number;
      }
    > = {};

    orderList.forEach((order) => {
      if (
        order.orderStatus === "Cancelled" ||
        order.orderStatus === "cancelled" ||
        order.orderStatus === "Tentative" ||
        order.orderStatus === "tentative"
      ) {
        return;
      }

      const hasCustomer = !!order.customer;

      order.orderItems.forEach((item) => {
        const key =
          item.menuItemId && item.menuItemId !== "undefined"
            ? item.menuItemId
            : item.displayName;

        if (!itemCounts[key]) {
          itemCounts[key] = {
            name: item.displayName,
            totalCount: 0,
            reservedCount: 0,
          };
        }

        itemCounts[key].totalCount += item.quantity;

        if (hasCustomer) {
          itemCounts[key].reservedCount += item.quantity;
        }
      });
    });

    return Object.values(itemCounts).sort(
      (a, b) => b.totalCount - a.totalCount,
    );
  };

  const getStatusBadgeColor = (status: string) => {
    switch (status) {
      case "Pending":              return "#F97316";
      case "AcceptedByCart":       return "#8B5CF6";
      case "ApprovedByRestaurant": return "#FFC107";
      case "Collecting":           return "#06B6D4";
      case "Preparing":            return "#0D6EFD";
      case "ReadyAtKitchen":       return "#212529";
      case "IssuedByKitchen":      return "#6366F1";
      case "ArrivedAtCart":        return "#EC4899";
      case "InAppCart":            return "#14B8A6";
      case "PackingComplete":      return "#84CC16";
      case "Completed":            return "#198754";
      case "Tentative":            return "#94A3B8";
      case "Cancelled":            return "#DC3545";
      default:                     return "#DC3545";
    }
  };

  const getStatusTextColor = (status: string) => {
    switch (status) {
      case "ApprovedByRestaurant":
      case "PackingComplete":
      case "Tentative":
        return "#333";
      default:
        return "#fff";
    }
  };

  const getStatusDisplayText = (status: string) => {
    switch (status) {
      case "Pending":              return "Pending";
      case "AcceptedByCart":       return "Accepted By Cart";
      case "ApprovedByRestaurant": return "Approved By Restaurant";
      case "Collecting":           return "Collecting";
      case "Preparing":            return "Preparing";
      case "ReadyAtKitchen":       return "Ready At Kitchen";
      case "IssuedByKitchen":      return "Issued By Kitchen";
      case "ArrivedAtCart":        return "Arrived At Cart";
      case "InAppCart":            return "In App Cart";
      case "PackingComplete":      return "Packing Complete";
      case "Completed":            return "Completed";
      case "Tentative":            return "Tentative";
      case "Cancelled":            return "Cancelled";
      default:                     return status;
    }
  };

  const columns: TableColumn<Order>[] = [
    {
      name: (
        <Input
          type="checkbox"
          checked={
            selectedOrders.length > 0 &&
            getSelectableOrders().length > 0 &&
            getSelectableOrders().every((order) =>
              selectedOrders.includes(order.id),
            )
          }
          onChange={handleSelectAllOrders}
          disabled={getSelectableOrders().length === 0}
          title={
            getSelectableOrders().length === 0
              ? "No selectable orders available"
              : "Select all"
          }
          className="large-checkbox"
        />
      ),
      cell: (row) => {
        if (!isOrderSelectable(row)) {
          return null;
        }

        return (
          <Input
            type="checkbox"
            checked={selectedOrders.includes(row.id)}
            onChange={() => handleOrderSelection(row.id)}
            className="large-checkbox"
          />
        );
      },
      width: "60px",
    },
    {
      name: <h6 className="fw-bold">Reorder</h6>,
      cell: (row: Order) => (
        <Button onClick={(e) => { e.stopPropagation(); handleReorder(row); }} variant="light">
          <FontAwesomeIcon icon={faRedo} color="#FF9A62" />
        </Button>
      ),
      width: "90px",
      center: true,
    },
    {
      name: <h6 className="fw-bold">Reference No</h6>,
      selector: (row) => row?.orderReference,
      sortable: true,
      cell: (row) => <strong>{row?.orderReference}</strong>,
      width: "160px",
    },
    {
      name: <h6 className="fw-bold">Status</h6>,
      cell: (row) => (
        <span
          style={{
            backgroundColor: getStatusBadgeColor(row?.orderStatus),
            color: getStatusTextColor(row?.orderStatus),
            fontSize: 12,
            padding: "5px 16px",
            borderRadius: "4px",
            display: "inline-block",
            fontWeight: 500,
          }}
        >
          {getStatusDisplayText(row?.orderStatus)}
        </span>
      ),
      sortable: true,
      center: true,
      width: "200px",
    },
    {
      name: <h6 className="fw-bold">Creator</h6>,
      selector: (row) =>
        row?.orderCreatedBy === ORDER_CREATED_BY_CART_PERSON
          ? "Cart Person"
          : row?.orderCreatedBy === ORDER_CREATED_BY_CUSTOMER
            ? "Customer"
            : "Restaurant",
      sortable: true,
      cell: (row) =>
        row?.orderCreatedBy === ORDER_CREATED_BY_CART_PERSON ? (
          <>Cart Person</>
        ) : row?.orderCreatedBy === ORDER_CREATED_BY_CUSTOMER ? (
          <>Customer</>
        ) : (
          <>{row.orderTakenBy?.displayName || "Restaurant"}</>
        ),
      width: "150px",
    },
    {
      name: <h6 className="fw-bold">Name</h6>,
      selector: (row: Order) => {
        if (row.orderCreatedBy === "Customer" && row.customer) {
          return row.customer.displayName;
        }
        if (row.orderCreatedBy === "Restaurant") {
          if (row.organization) {
            return row.organization.displayName;
          } else if (row.customer) {
            return row.customer.displayName;
          } else if (row.cart?.displayName) {
            return row.cart.displayName;
          }
        }
        if (row.cart?.displayName) {
          return row.cart.displayName;
        }
        return row.orderCreatedBy;
      },
      sortable: true,
      cell: (row: Order) => {
        let creatorName = row.orderCreatedBy;

        if (row.orderCreatedBy === "Customer" && row.customer) {
          creatorName = row.customer.displayName;
        } else if (row.orderCreatedBy === "Restaurant") {
          if (row.organization) {
            creatorName = row.organization.displayName;
          } else if (row.customer) {
            creatorName = row.customer.displayName;
          } else if (row.cart?.displayName) {
            creatorName = row.cart.displayName;
          }
        } else if (row.cart?.displayName) {
          creatorName = row.cart.displayName;
        }
        return <div className="d-flex align-items-center">{creatorName}</div>;
      },
      width: "150px",
    },
    {
      name: <h6 className="fw-bold">Cart</h6>,
      selector: (row) => row?.cart?.displayName || "No Cart",
      sortable: true,
      width: "160px",
    },
    {
      name: <h6 className="fw-bold">Payment Method</h6>,
      selector: (row: Order) => row.paymentMethod || "",
      sortable: true,
      cell: (row: Order) => <div>{row.paymentMethod}</div>,
      width: "120px",
    },
    {
      name: <h6 className="fw-bold">Created Date</h6>,
      selector: (row) => formatFirestoreTimestamp(row?.createdAt),
      sortable: true,
      cell: (row) => <div>{formatFirestoreTimestamp(row?.createdAt)}</div>,
      width: "160px",
    },
    {
      name: <h6 className="fw-bold">Phone No</h6>,
      selector: (row) =>
        row?.phoneNumber || row.customer?.phoneNumber || "No Phone number",
      sortable: true,
      width: "150px",
    },
    {
      name: <h6 className="fw-bold">Action</h6>,
      center: true,
      cell: (row: Order) => (
        <Button onClick={() => handleViewDetails(row)} variant="light">
          <FontAwesomeIcon icon={faEye} color="#FF9A62" />
        </Button>
      ),
      width: "90px",
    },
  ];

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />

      <div className="pickup-order-management-container">
        <div className="header">
          <div className="header-content d-flex justify-content-between align-items-center">
            <h1 className="title">Pickup Orders</h1>
            <div className="d-flex align-items-center gap-3">
              <FormGroup check className="mb-0  ">
                <Input
                  type="checkbox"
                  id="viewToggle"
                  checked={showSummaryView}
                  onChange={() => setShowSummaryView(!showSummaryView)}
                  className="form-check-input"
                />
                <Label for="viewToggle" check className="form-check-label">
                  Product wise View
                </Label>
              </FormGroup>
              <button
                className="btn btn-outline-primary"
                onClick={handlePrintModalOpen}
                disabled={orderList.length === 0}
              >
                <FontAwesomeIcon icon={faPrint} className="me-2" />
                Print
              </button>
            </div>
          </div>
        </div>

        <Card className="mb-0 mt-1">
          <CardBody>
            <Row className="align-items-end">
              <Col lg="5" className="mb-2 mt-2">
                <Input
                  type="text"
                  value={searchQuery}
                  placeholder="Search using Order Ref, Phone Number, or Customer/ Organization Name"
                  onChange={handleSearchQueryChange}
                />
              </Col>
            </Row>

            <Row className="align-items-end">
              <Col lg="2" className="mb-3">
                <Label>Order Created By</Label>
                <Select
                  isMulti={false}
                  name="orderType"
                  value={orderType}
                  options={USER_TYPE}
                  onChange={handleOrderCreatedByChange}
                />
              </Col>

              <Col lg="2" className="mb-3">
                <Label>Organization</Label>
                <Select
                  isMulti={false}
                  name="organization"
                  value={selectedOrganization}
                  options={organizationOptions}
                  onChange={handleOrganizationChange}
                  isClearable={true}
                  placeholder="Select organization..."
                />
              </Col>

              <Col lg="2" className="mb-3">
                <Label>Cart Name</Label>
                <Select
                  isMulti={false}
                  name="cartName"
                  value={selectedCart}
                  isSearchable={true}
                  isClearable={true}
                  isLoading={cartsLoading}
                  onInputChange={handleInputChange}
                  onChange={handleCartSelect}
                  options={searchOptions}
                  placeholder={cartsLoading ? "Loading..." : "Select cart..."}
                />
              </Col>

              <Col lg="2" className="mb-3">
                <Label>Start Date</Label>
                <Input
                  type="date"
                  value={startDate.split("T")[0]}
                  max={endDate.split("T")[0]}
                  onChange={handleOrderDateChange}
                />
              </Col>

              <Col lg="2" className="mb-3">
                <Label>End Date</Label>
                <Input
                  type="date"
                  value={endDate.split("T")[0]}
                  min={startDate.split("T")[0]}
                  onChange={handleOrderEndDateChange}
                />
              </Col>

              <Col lg="2" className="mb-3">
                <Label>Order Status</Label>
                <Select
                  isMulti={false}
                  name="orderStatus"
                  value={selectedOrderStatus}
                  options={ORDERS_STATUS}
                  onChange={handleStatusChange}
                />
              </Col>

              <Col lg="2" className="mb-3">
                <Label>Agent / Source</Label>
                <Select
                  isMulti={false}
                  name="agentSource"
                  value={selectedAgent}
                  options={agentOptions}
                  onChange={handleAgentChange}
                  isClearable={true}
                  placeholder="Select agent or source..."
                />
              </Col>

              <Col lg="2" className="mb-3">
                <Label>Bulk Actions</Label>
                <Select
                  isMulti={false}
                  name="bulkAction"
                  value={bulkAction}
                  options={filteredBulkActions}
                  onChange={handleBulkActionChange}
                  placeholder="Select action..."
                  isDisabled={selectedOrders.length === 0}
                />
              </Col>

              <Col lg="2" className="mb-3">
                {selectedOrders.length > 0 && (
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <Badge color="success" className="p-2">
                      {selectedOrders.length} orders selected
                    </Badge>
                    {currentStatusForSelected && (
                      <Badge color="info" className="p-2">
                        Status:{" "}
                        {getStatusDisplayText(currentStatusForSelected)}
                      </Badge>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            {isLoading ? (
              <TableLoadingComponent numColumns={5} />
            ) : showSummaryView ? (
              <DataTable
                title="Menu Item Summary"
                columns={[
                  {
                    name: <h6 className="fw-bold">Menu Item</h6>,
                    selector: (row) => row.name,
                    sortable: true,
                    cell: (row) => <strong>{row.name}</strong>,
                  },
                  {
                    name: <h6 className="fw-bold">Total Quantity</h6>,
                    selector: (row) => row.totalCount,
                    sortable: true,
                    cell: (row) => <strong>{row.totalCount}</strong>,
                  },
                  {
                    name: <h6 className="fw-bold">Reserved Items</h6>,
                    selector: (row) => row.reservedCount,
                    sortable: true,
                    cell: (row) => <strong>{row.reservedCount}</strong>,
                  },
                  {
                    name: <h6 className="fw-bold">Available Quantity</h6>,
                    sortable: true,
                    cell: (row) => (
                      <strong>{row.totalCount - row.reservedCount}</strong>
                    ),
                  },
                ]}
                data={getMenuItemCounts()}
                pagination
                responsive
                highlightOnHover
                paginationPerPage={rowsPerPage}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
              />
            ) : (
              <DataTable
                title=""
                columns={columns}
                data={orderList}
                pagination
                responsive
                highlightOnHover
                paginationPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onRowClicked={handleViewDetails}
                pointerOnHover
              />
            )}
          </CardBody>
        </Card>

        <PrintSetupModal
          showModal={showOrderPrintModal}
          handleModalClose={handleOrderPrintModalClose}
          orderList={orderList}
          cartName={selectedCart?.displayName || cartName}
          orderDate={
            startDate && endDate
              ? `${dateTFormat(new Date(startDate))} - ${dateTFormat(new Date(endDate))}`
              : startDate
                ? dateTFormat(new Date(startDate))
                : ""
          }
          isAllCartsSelected={selectedCart?.cartId === "all"}
          isSummaryView={false}
        />

        <ProductSummaryPrintModal
          showModal={showProductPrintModal}
          handleModalClose={handleProductPrintModalClose}
          orderList={orderList}
          cartName={selectedCart?.displayName || cartName}
          orderDate={
            startDate && endDate
              ? `${dateTFormat(new Date(startDate))} - ${dateTFormat(new Date(endDate))}`
              : startDate
                ? dateTFormat(new Date(startDate))
                : ""
          }
          isAllCartsSelected={selectedCart?.cartId === "all"}
          menuItemCounts={getMenuItemCounts()}
        />

        <Modal
          isOpen={showBulkStatusModal}
          toggle={() => setShowBulkStatusModal(false)}
        >
          <ModalHeader toggle={() => setShowBulkStatusModal(false)}>
            Update Order Status
          </ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <Label>Current Status</Label>
              <Input
                type="text"
                value={getStatusDisplayText(currentStatusForSelected)}
                readOnly
              />
            </div>
            <div className="mb-3">
              <Label>Next Status</Label>
              <Input
                type="text"
                value={nextStatusOption?.label || ""}
                readOnly
              />
            </div>
            <div className="mb-3">
              <Label>Number of Orders</Label>
              <Input type="text" value={selectedOrders.length} readOnly />
            </div>
          </ModalBody>
          <ModalFooter>
            <ButtonComponent
              onClick={() => setShowBulkStatusModal(false)}
              titel="Cancel"
            />
            <ButtonComponent
              onClick={handleBulkActionSubmit}
              isDisabled={isUpdatingBulkStatus}
              titel={isUpdatingBulkStatus ? "Processing..." : "Update"}
            />
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={showConfirmModal}
          toggle={() => setShowConfirmModal(false)}
        >
          <ModalHeader toggle={() => setShowConfirmModal(false)}>
            Confirm Order Issuance
          </ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <Label>Number of Orders to Issue</Label>
              <Input type="text" value={selectedOrders.length} readOnly />
            </div>
            <div className="alert alert-warning">
              Are you sure you want to issue these {selectedOrders.length}{" "}
              orders?
            </div>
          </ModalBody>
          <ModalFooter>
            <ButtonComponent
              onClick={() => setShowConfirmModal(false)}
              titel="Cancel"
            />
            <ButtonComponent
              onClick={handleIssueOrders}
              isDisabled={isIssuingBulkOrder}
              titel={isIssuingBulkOrder ? "Processing..." : "Yes, Issue Orders"}
            />
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default OrderListNew;